import {
  FETCH_DELETE_DETAIL_CATEGORY_SUCCESS,
  FETCH_DETAIL_CATEGORY_SUCCESS,
  FETCH_LIST_CATEGORY_SUCCESS,
} from "redux/ActionTypes/CategoryActionTypes";

const initialState = {
  list: [],
  detail: null,
};

const CategoryReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_CATEGORY_SUCCESS: {
      const newList = [...action.payload];
      return { ...state, list: newList };
    }
    case FETCH_DETAIL_CATEGORY_SUCCESS: {
      const newDetail = { ...action.payload };
      return { ...state, detail: newDetail };
    }
    case FETCH_DELETE_DETAIL_CATEGORY_SUCCESS: {
      return { ...state, detail: null };
    }
    default:
      return { ...state };
  }
};

export default CategoryReducers;
